"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconStopwatch = function SvgIconStopwatch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "stopwatch icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Stopwatch Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.415 18.375l1.76-1.766a.94.94 0 000-1.328l-1.324-1.328a.932.932 0 00-1.323 0l-1.611 1.617a16.055 16.055 0 00-8.858-3.968V7.75h2.18a.939.939 0 00.933-.938V4.938A.939.939 0 0028.238 4h-8.095a.939.939 0 00-.934.938v1.875c0 .515.42.937.934.937h2.18v3.86C14.257 12.54 8 19.405 8 27.75 8 36.727 15.247 44 24.19 44c8.944 0 16.191-7.273 16.191-16.25a16.21 16.21 0 00-2.966-9.375zM24.19 40.25c-6.88 0-12.454-5.594-12.454-12.5s5.574-12.5 12.454-12.5c6.881 0 12.455 5.594 12.455 12.5s-5.574 12.5-12.455 12.5zm.935-8.75h-1.869a.939.939 0 01-.934-.938V19.938c0-.515.42-.937.934-.937h1.869a.94.94 0 01.934.938v10.625c0 .515-.42.937-.934.937z"
  }));
};

var _default = SvgIconStopwatch;
exports.default = _default;